import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import Rightbar from './Rightbar'
import { PGET, GET, POST } from 'helpers/api'
import { formatDateWithTime, returnSign, formatDateBackend, findFromArrayById, formatMoney, formatDate } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)
	const location = useLocation()
	const repairEnabled = new URLSearchParams(location.search).get('repair') === '1'

	const currencies = [{ "id": 1, "name": "So`m" }, { "id": 2, "name": "USD" }]
	const statuses = [{ "id": 0, "name": t('SUCCESS') }, { "id": 1, "name": t('PARTIAL_RETURN') }, { "id": 2, "name": t('RETURN') }, { "id": 3, "name": t('DISCOUNT') }]
	const paymentTypes = [{ 'id': 1, 'name': t('CASH') }, { 'id': 2, 'name': t('TERMINAL') }]

	const [poses, setPoses] = useState([])
	const [cashiers, setCashiers] = useState([])

	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [totalCount, setTotalCount] = useState(0)
	const [totalAmount, setTotalAmont] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const date = new Date()
	const [filterData, setFilterData] = useState({
		posId: reduxAccount.posId,
		cashierId: null,
		currencyId: null,
		returned: null,
		paymentTypeId: null,
		startDate: formatDateBackend(new Date(date.getFullYear(), date.getMonth(), 1)),
		endDate: formatDateBackend(new Date()),
		search: ''
	})
	const [pagination, setPagination] = useState({
		url: '/services/web/api/cheque-pageList',
		response: null
	})
	const [data, setData] = useState([])
	const [repairModal, setRepairModal] = useState({ open: false, mode: null, item: null, data: null })

	const tableTotalAmount = useMemo(() => {
		if (!data?.length) return 0
		return data.reduce((sum, item) => sum + (Number(item?.totalPrice) || 0), 0)
	}, [data])

	const REPAIR_STATUS_UZ = {
		OK: "TO'G'RI",
		MISMATCH: "MOS EMAS",
		SKIPPED: "O'TKAZILDI",
		PREVIEW: "OLDINDAN KO'RISH",
		APPLIED: "BAJARILDI",
		PARTIAL_FAILURE: "QISMAN MUVAFFAQIYATSIZ",
		NO_DEFICIT: "KAMOMAD YO'Q",
		NO_RETURNS: "QAYTARISHLAR YO'Q",
		NO_INITIAL_DEBT: "DASTLABKI QARZ YO'Q",
		SAME_CURRENCY_NO_ACTION: "BIR XIL VALYUTA - HARAKAT YO'Q",
		INVALID_CHEQUE_STATE: "CHEK HOLATI NOTO'G'RI",
		CHEQUE_NOT_FOUND: "CHEK TOPILMADI",
		MISMATCHES_FOUND: "MOSSIZLIKLAR TOPILDI",
		ERROR: "XATOLIK",
		FIXED: "TUZATILDI",
		WOULD_FIX: "TUZATISH MUMKIN",
		NOT_FIXABLE: "TUZATIB BO'LMAYDI",
		NOT_APPLICABLE: "TEGISHLI EMAS",
		FAILED: "MUVAFFAQIYATSIZ",
	}
	const uzStatus = s => (s ? REPAIR_STATUS_UZ[s] || s : '-')

	function closeRepairModal() {
		setRepairModal({ open: false, mode: null, item: null, data: null })
	}

	async function openInspectModal(e, item) {
		if (e) e.stopPropagation()
		const posId = item.posId || filterData.posId
		if (!item?.chequeNumber || !posId) {
			toast.error("Chek raqami yoki posId topilmadi")
			return
		}
		const resp = await GET(`/services/web/api/inspect-cheque/${item.chequeNumber}/${posId}`, {}, { loader: true })
		if (!resp) return
		if (resp.status === 'CHEQUE_NOT_FOUND' || resp.status === 'ERROR') {
			toast.error(`${uzStatus(resp.status)}: ${resp.message || ''}`)
			return
		}
		setRepairModal({ open: true, mode: 'inspect', item, data: resp })
	}

	async function openRepairModal(e, item) {
		if (e) e.stopPropagation()
		const posId = item.posId || filterData.posId
		if (!item?.chequeNumber || !posId) {
			toast.error("Chek raqami yoki posId topilmadi")
			return
		}
		const previewResp = await POST(`/services/web/api/repair-cheque-return/${item.chequeNumber}/${posId}?dryRun=true`, {}, { loader: true })
		const preview = previewResp?.data
		if (!preview) return
		if (preview.status === 'CHEQUE_NOT_FOUND' || preview.status === 'ERROR') {
			toast.error(`${uzStatus(preview.status)}: ${preview.message || ''}`)
			return
		}
		setRepairModal({ open: true, mode: 'repair', item, data: preview })
	}

	async function applyRepairFromModal() {
		const item = repairModal.item
		if (!item) return
		const posId = item.posId || filterData.posId
		const applyResp = await POST(`/services/web/api/repair-cheque-return/${item.chequeNumber}/${posId}?dryRun=false`, {}, { loader: true, message: false })
		const applied = applyResp?.data
		if (!applied) return
		setRepairModal({ open: true, mode: 'repair', item, data: applied })
		if (applied.status === 'APPLIED') toast.success(`${uzStatus(applied.status)}. ${applied.message || ''}`)
		else if (applied.status === 'OK') toast.info(uzStatus('NO_DEFICIT'))
		else toast.error(`${uzStatus(applied.status)}: ${applied.message || ''}`)
	}

	function checkStatusBadge(s) {
		const cls = s === 'OK' ? 'bg-success' : s === 'MISMATCH' ? 'bg-danger' : 'bg-secondary'
		return <span className={`badge ${cls}`}>{uzStatus(s)}</span>
	}

	function fixStatusBadge(s) {
		if (!s) return <span className="text-muted">-</span>
		const cls = s === 'FIXED' ? 'bg-success' :
			s === 'WOULD_FIX' ? 'bg-warning text-dark' :
			s === 'FAILED' ? 'bg-danger' :
			s === 'NOT_FIXABLE' ? 'bg-secondary' :
			'bg-light text-dark'
		return <span className={`badge ${cls}`}>{uzStatus(s)}</span>
	}

	const fmtNum = v => (v === null || v === undefined ? '-' : Number(v).toFixed(4))

	async function toggleRightbar(boolean = false, item, index) {
		var dataCopy = [...data]

		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/services/web/api/cheque-itemsList/` + item.id, {}, { loader: true })
			dataCopy[index]['itemsList'] = response
			dataCopy[index]['showSidebar'] = boolean

			setSelectedItem(dataCopy[index])
			setShowRightBar(boolean)
		} else {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	async function searchWithFilter(exportToExcel = false) {
		var filterUrl = `/services/web/api/cheque-pageList/${filterData.posId}`
		var urlParams = ""
		checkFilter()

		if (filterData.cashierId)
			urlParams += returnSign(urlParams) + 'cashierId=' + filterData.cashierId
		if (filterData.currencyId)
			urlParams += returnSign(urlParams) + 'currencyId=' + filterData.currencyId
		if (filterData.returned)
			urlParams += returnSign(urlParams) + 'returned=' + filterData.returned
		if (filterData.paymentTypeId)
			urlParams += returnSign(urlParams) + 'paymentTypeId=' + filterData.paymentTypeId
		if (filterData.startDate)
			urlParams += returnSign(urlParams) + 'startDate=' + filterData.startDate
		if (filterData.endDate)
			urlParams += returnSign(urlParams) + 'endDate=' + filterData.endDate
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		if (`/services/web/api/cheque-pageList/${filterData.posId}` + urlParams !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		if (exportToExcel) {
			filterUrl = `/services/web/api/cheque-excel/${filterData.posId}` + urlParams + returnSign(filterUrl)

			var excelHeaders = [[t('POS'), t('CASHBOX'), t('SHIFT_NUMBER'), t('CASHIER'), t('CHECK_NUMBER'), t('CHEQUE_DATE'),
			t('SYNC_DATE'), t('STATUS'), t('TOTAL')]]
			const response = await GET(filterUrl)
			for (let i = 0; i < response.length; i++) {
				var excelItems = []
				excelItems.push(response[i].posName)
				excelItems.push(response[i].cashboxName)
				excelItems.push(response[i].shiftNumber)
				excelItems.push(response[i].cashierName)
				excelItems.push(response[i].chequeNumber)
				excelItems.push(formatDateWithTime(response[i].chequeDate))
				excelItems.push(formatDateWithTime(response[i].createdDate))
				if (response[i].returned === 0) excelItems.push(t('SUCCESS'))
				if (response[i].returned === 1) excelItems.push(t('PARTIAL_RETURN'))
				if (response[i].returned === 2) excelItems.push(t('RETURN'))
				excelItems.push(response[i].totalPrice)
				excelHeaders.push(excelItems)
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('CHEQUES') + ".xlsx");
		} else {
			const response = await PGET(filterUrl, {}, { loader: true })
			if (response) {
				setTotalCount(response.headers['x-total-count'])
				setData(response.data)
				setPagination({ ...pagination, 'url': filterUrl, 'response': response })
			}
			filterUrl = `/services/web/api/cheque-total/${filterData.posId}` + urlParams
			const temporaryTotalAmount = await GET(filterUrl)
			setTotalAmont(temporaryTotalAmount)
		}

		setDropdownIsOpen(false)
	}

	async function resetFilter() {
		var filterUrl = `/services/web/api/cheque-pageList/${filterData.posId}`

		setFilterData({
			...filterData,
			cashierId: null,
			currencyId: null,
			returned: null,
			paymentTypeId: null,
			startDate: null,
			endDate: null,
			search: ''
		})

		const response = await PGET(filterUrl, {}, { loader: true })
		if (response) {
			setTotalCount(response.headers['x-total-count'])
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response })
		}
		filterUrl = `/services/web/api/cheque-total/${filterData.posId}`
		const temporaryTotalAmount = await GET(filterUrl)
		setTotalAmont(temporaryTotalAmount)
		
	}
	

	async function getData() {
		const response = await PGET(`/services/web/api/cheque-pageList/${reduxAccount.posId}`, {}, { loader: true })
		if (response) {
			setData(response.data)
			setPagination({ ...pagination, 'url': `/services/web/api/cheque-pageList/${filterData.posId}`, 'response': response })
		}
	}

	async function checkFilter() {
		if (
			filterData.posId === null &&
			filterData.cashierId === null &&
			filterData.currencyId === null &&
			filterData.returned === null &&
			filterData.startDate === null &&
			filterData.endDate === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		} else {
			setFilterDataExist(true)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			setPoses(response)
		}
	}

	async function getCashiers() {
		const response = await GET('/services/web/api/cashier-helper')
		if (response) {
			setCashiers(response)
		}
	}

	async function paginate(newPageData) {
		setData(newPageData)
	}

	useEffect(() => {
		getPoses()
		getCashiers()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter(false)
	}, [filterData.search]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex mb-2">
				<h4 className="vertical-center">
					{t('CHEQUES')} [{totalCount}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CASHIER')}</label>
												<Select
													options={cashiers}
													value={cashiers.find(option => option.id === filterData.cashierId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'cashierId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('CHOOSE_PAYMENT_TYPE')}</label>
												<Select
													options={paymentTypes}
													value={paymentTypes.find(option => option.id === filterData.paymentTypeId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'paymentTypeId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CURRENCY')}</label>
												<Select
													options={currencies}
													value={currencies.find(option => option.id === filterData.currencyId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'currencyId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('STATUS')}</label>
												<Select
													options={statuses}
													value={statuses.find(option => option.id === filterData.returned) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'returned': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide" onClick={() => searchWithFilter(true)}>
									EXCEL
								</button>
							</div>
						</div>

						<div>
							<div className="d-flex justify-content-between">
								<div className="vertical-center">
									{totalAmount?.map((item, index) => (
										<React.Fragment key={index}>
											{item.currencyName === "USD" &&
												<div className="d-flex">
													<div className="w-100">
														<h5 className="text-end" key={index}>
															<div className="d-flex justify-content-between">
																<h5><b>{t('TOTAL_AMOUNT')}:</b></h5>
																{formatMoney(item.totalAmount)} {item.currencyName}
															</div>
															<div className="d-flex justify-content-between">
																<h5 className="me-3"><b>{t('TOTAL_AMOUNT_RETURN')}:</b></h5>
																{formatMoney(item.returnAmount)} {item.currencyName}
															</div>
														</h5>
													</div>
												</div>
											}

											{item.currencyName !== "USD" &&
												<div className="d-flex">
													<div>
														<h5 className="text-end" key={index}>
															<div className="d-flex justify-content-between">
																<h5><b>{t('TOTAL_AMOUNT')}:</b></h5>
																{formatMoney(item.totalAmount)} {item.currencyName}
															</div>
															<div className="d-flex justify-content-between">
																<h5 className="me-3"><b>{t('TOTAL_AMOUNT_RETURN')}:</b></h5>
																{formatMoney(item.returnAmount)} {item.currencyName}
															</div>
														</h5>
													</div>
												</div>
											}

										</React.Fragment>
									))}
								</div>
							</div>

						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate &&
											<span>{formatDate(filterData.startDate)}</span>
										}
										{(filterData.startDate && filterData.endDate) &&
											<span>|</span>
										}
										{filterData.endDate &&
											<span>{formatDate(filterData.endDate)}</span>
										}
									</span>
								}
								{filterData.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
								}
								{filterData.cashierId &&
									<span className="me-2">
										<b>{t('CASHIER')}: </b> {findFromArrayById(cashiers, filterData.cashierId)}
									</span>
								}
								{filterData.paymentTypeId &&
									<span className="me-2">
										<b>{t('PAYMENT_METHOD')}: </b> {findFromArrayById(paymentTypes, filterData.paymentTypeId)}
									</span>
								}
								{(filterData.returned >= 0 && filterData.returned != null) &&
									<span className="me-2">
										<b>{t('STATUS')}: </b>
										{filterData.returned === 0 &&
											<span>{t('SUCCESS')}</span>
										}
										{findFromArrayById(statuses, filterData.returned)}
									</span>
								}
								{filterData.currencyId &&
									<span className="me-2">
										<b>{t('CURRENCY')}: </b> {findFromArrayById(currencies, filterData.currencyId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="d-flex align-items-center">
								<div className="me-3 text-nowrap">
									<b>{t('TOTAL')}:</b> {formatMoney(tableTotalAmount)}
								</div>
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-hover mb-0">
							<thead>
								<tr>
									<th>{t('POS')}</th>
									<th className="text-center">{t('CASHBOX')}</th>
									<th className="text-center">{t('SHIFT_NUMBER')}</th>
									<th className="text-center">{t('CASHIER')}</th>
									<th className="text-center">{t('CHECK_NUMBER')}</th>
									<th className="text-center">{t('CLIENT')}</th>
									<th className="text-center">{t('ORGANIZATION')}</th>
									<th className="text-center">{t('CHEQUE_DATE')}</th>
									<th className="text-center">{t('SYNC_DATE')}</th>
									<th className="text-center">{t('STATUS')}</th>
									<th className="text-center">{t('TOTAL')}</th>
									{repairEnabled && <th className="text-center">Tuzatish</th>}
								</tr>
							</thead>
							<tbody>
								{data.length > 0 ? data.map((item, index) => (
									<tr className={'cursor ' + (item.showSidebar ? 'table-tr-active' : '')}
										key={index} onClick={() => toggleRightbar(true, item, index)}>
										<td>{item.rowNum}. {item.posName}</td>
										<td className="text-center">{item.cashboxName}</td>
										<td className="text-center">{item.shiftNumber}</td>
										<td className="text-center">{item.cashierName}</td>
										<td className="text-center">{item.chequeNumber}</td>
										<td className="text-center">{item.clientName}</td>
										<td className="text-center">{item.organizationName}</td>
										<td className="text-center">{formatDateWithTime(item.chequeDate)}</td>
										<td className="text-center">{formatDateWithTime(item.createdDate)}</td>
										<td className="text-center">
											{item.returned === 0 &&
												<span className="bg-success bg-border text-white">{t('SUCCESS')}</span>
											}
											{item.returned === 1 &&
												<span className="bg-warning bg-border text-white text-nowrap">{t('PARTIAL_RETURN')}</span>
											}
											{item.returned === 2 &&
												<span className="bg-danger bg-border text-white">{t('RETURN')}</span>
											}
										</td>
										<td className="text-center text-nowrap">
											<span className={item.clientAmount > 0 ? "text-danger" : ""} title={item.clientAmount > 0 ? t('SOLD_ON_CREDIT') : ""}>
												{formatMoney(item.totalPrice)}
											</span>
										</td>
										{repairEnabled &&
											<td className="text-center text-nowrap" onClick={(e) => e.stopPropagation()}>
												<button
													type="button"
													className="btn btn-sm btn-outline-info me-1"
													title="Chek uchun barcha tekshiruvlarni bajarish (faqat o'qish)"
													onClick={(e) => openInspectModal(e, item)}>
													Tekshirish
												</button>
												<button
													type="button"
													className="btn btn-sm btn-outline-warning"
													title="Chekdagi mossizliklarni tuzatish (oldindan ko'rish, keyin qo'llash)"
													onClick={(e) => openRepairModal(e, item)}>
													Tuzatish
												</button>
											</td>
										}
									</tr>
								)): <tr>
										<td colSpan={repairEnabled ? "11" : "10"} className="text-center">{t('NO_DATA')}</td>
									</tr>

								}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Rightbar showRightBar={showRightBar} setShowRightBar={setShowRightBar} selectedItem={selectedItem}></Rightbar>

			<Modal show={repairModal.open} onHide={closeRepairModal} size="xl" scrollable>
				<Modal.Header closeButton>
					<Modal.Title>
						Chek {repairModal.item?.chequeNumber}
						{repairModal.data?.chequeId ? ` (id ${repairModal.data.chequeId})` : ''}
						{' — '}
						{repairModal.mode === 'repair' ? 'Tuzatish' : 'Tekshirish'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{repairModal.data && (
						<>
							<div className="mb-3">
								<b>Holat:</b> <span className="me-2">{uzStatus(repairModal.data.status)}</span>
								<span className="text-muted">{repairModal.data.message}</span>
							</div>
							<div className="table-responsive">
								<table className="table table-sm table-bordered mb-0">
									<thead className="table-light">
										<tr>
											<th style={{ minWidth: 240 }}>Tekshiruv</th>
											<th className="text-center">Holat</th>
											<th className="text-end">Haqiqiy</th>
											<th className="text-end">Kutilgan</th>
											<th className="text-end">Δ</th>
											{repairModal.mode === 'repair' && <th className="text-center">Tuzatish holati</th>}
											{repairModal.mode === 'repair' && <th>Amal / izoh</th>}
										</tr>
									</thead>
									<tbody>
										{(repairModal.data.checks || []).map((c, i) => (
											<tr key={i}>
												<td>
													<div style={{ fontSize: 12, fontFamily: 'monospace' }}>{c.kind}</div>
													{c.description && <div className="text-muted" style={{ fontSize: 11 }}>{c.description}</div>}
												</td>
												<td className="text-center">{checkStatusBadge(c.status)}</td>
												<td className="text-end" style={{ fontFamily: 'monospace' }}>{fmtNum(c.actual)}</td>
												<td className="text-end" style={{ fontFamily: 'monospace' }}>{fmtNum(c.expected)}</td>
												<td className="text-end" style={{ fontFamily: 'monospace', color: (c.delta !== null && Math.abs(c.delta) > 0.01) ? '#c00' : undefined }}>{fmtNum(c.delta)}</td>
												{repairModal.mode === 'repair' && <td className="text-center">{fixStatusBadge(c.fixStatus)}</td>}
												{repairModal.mode === 'repair' && (
													<td style={{ fontSize: 11 }}>
														{c.fixAction || c.note || ''}
													</td>
												)}
											</tr>
										))}
									</tbody>
								</table>
							</div>
							{repairModal.mode === 'repair' && repairModal.data.status !== 'APPLIED' && (
								<div className="mt-3 alert alert-warning" style={{ fontSize: 12 }}>
									Tuzatish qo'llansa: cheque_repair_backup jadvaliga to'liq zaxira yoziladi, keyin
									cheque + clients_balance_history + clients_balance jadvallari yangilanadi. Muvaffaqiyatsiz
									bo'lsa, butun tranzaksiya bekor qilinadi.
								</div>
							)}
						</>
					)}
				</Modal.Body>
				<Modal.Footer>
					{repairModal.mode === 'repair' && repairModal.data?.status === 'PREVIEW' &&
						(repairModal.data.checks || []).some(c => c.fixStatus === 'WOULD_FIX') && (
						<button type="button" className="btn btn-warning" onClick={applyRepairFromModal}>
							Tuzatishni qo'llash
						</button>
					)}
					<button type="button" className="btn btn-secondary" onClick={closeRepairModal}>
						Yopish
					</button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default Index
